import { getStoreAccessors } from 'typesafe-vuex';
import { LandingPageState } from './state';
import { IAccountProfileOpen, ILanguage, ICurrency, IState, ICity, ICountry, IAccountCreationResult } from '@/interfaces';
import { State } from '../state';

export const mutations = {
    setProfiles(state: LandingPageState, payload: IAccountProfileOpen[]) {
        state.profiles = payload;
    },
    setLanguages(state: LandingPageState, payload: ILanguage[]) {
        state.languages = payload;
    },
    setCurrencies(state: LandingPageState, payload: ICurrency[]) {
        state.currencies = payload;
    },
    setStates(state: LandingPageState, payload: IState[]) {
        state.states = payload;
    },
    setCities(state: LandingPageState, payload: ICity[]) {
        state.cities = payload;
    },
    setCountries(state: LandingPageState, payload: ICountry[]) {
        state.countries = payload;
    },
    setAccountCreationResult(state: LandingPageState, payload: IAccountCreationResult) {
        //console.log(payload.success)
        state.account_creation_result = payload;
    }
};

const { commit } = getStoreAccessors<LandingPageState, State>('');

export const commitSetProfiles = commit(mutations.setProfiles);
export const commitSetStates = commit(mutations.setStates);
export const commitSetCities = commit(mutations.setCities);
export const commitSetCountries = commit(mutations.setCountries);
export const commitSetLanguages = commit(mutations.setLanguages);
export const commitSetCurrencies = commit(mutations.setCurrencies);
export const commitAccountCreationResult = commit(mutations.setAccountCreationResult);
